import React from 'react';

// npm install japan-postal-code
// https://www.npmjs.com/package/japan-postal-code?activeTab=readme

import postal_code from 'japan-postal-code';

import * as ht from './_ht';
import * as hf from './_hf';

export const getArsAsync = ( // get address
  code: ht.s,
): Promise<ht.dz|undefined> => new Promise( _exit => {
  postal_code.get(code, (_ars: ht.dz) => {
    const _dz = {
      ars1: _ars.prefecture,
      ars2: _ars.city,
      ars3: _ars.area,
      ars4: _ars.street,
    };
    if (hf.f(_dz)) {
      _exit(_dz);
    }
    else {
      _exit(undefined);
    }
  });
});

/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
